var React = require('react');

function HalfcInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.4598 14.1499C23.9317 9.8685 22.4728 4.39849 18.2012 1.9323C13.9297 -0.533871 8.46306 0.937687 5.99117 5.21912C4.07201 8.5432 4.52229 12.5838 6.8187 15.3787C-7.01625 45.6842 4.15713 82.08 33.5304 99.0387C34.1021 99.3688 34.6767 99.6892 35.2541 100H55.98L56.3408 99.3751C49.8184 98.2531 43.3816 95.9802 37.3176 92.4791C11.3861 77.5076 1.49682 45.4034 13.6414 18.6322C16.7531 18.6523 19.7898 17.0423 21.4598 14.1499Z","fill":"#DDDDDD"}));
}

HalfcInline.defaultProps = {"width":"57","height":"100","viewBox":"0 0 57 100","fill":"none"};

module.exports = HalfcInline;

HalfcInline.default = HalfcInline;
